import { Injectable } from '@angular/core';
import * as moment from 'moment';
import {  of, Subscription } from 'rxjs';
import { CandleChartWebfeederSktService } from 'src/app/core/services/candle-chart-webfeeder-skt.service';
import { LogService } from 'src/app/core/services/log.service';
import { NotificationAlertService } from 'src/app/core/services/notification-alert.service';
import { WebfeederHttpService } from 'src/app/core/services/webfeeder-http.service';

import { Bar, DatafeedConfiguration,  DatafeedErrorCallback,  GetMarksCallback, HistoryCallback, HistoryMetadata, IBasicDataFeed, IDatafeedQuotesApi, LibrarySymbolInfo, Mark, OnReadyCallback, PeriodParams, QuotesCallback, ResolutionString, ResolveCallback, SearchSymbolsCallback, SubscribeBarsCallback, SymbolResolveExtension, TimescaleMark } from 'src/assets/charting_library/charting_library';

import { environment } from 'src/environments/environment';

function defaultConfiguration(): DatafeedConfiguration & { supports_search, supports_group_request } {
  return {
    supports_search: true,
    supports_group_request: false,
    supported_resolutions: ['1', '5', '10', '15', '30', '60', '1D', '1W', '1M'] as ResolutionString[],
    supports_marks: false,
    supports_timescale_marks: false,
    supports_time: false,
    exchanges: [
      {
        value: 'BMFBOVESPA',
        name: 'BM&F',
        desc: 'BM&F Bovespa'
      }
    ],
    symbols_types: [
      {
        name: 'All types',
        value: 'Todos'
      },
      {
        name: 'Stock',
        value: 'stock'
      },
      {
        name: 'Futures',
        value: 'futures'
      }
    ]
  };
}

@Injectable({
  providedIn: 'root'
})
export class DatafeedService implements IBasicDataFeed, IDatafeedQuotesApi {
  protected _configuration: DatafeedConfiguration = defaultConfiguration();

  _config: DatafeedConfiguration & { supports_search, supports_group_request };
  _datafeedUrl = environment.BASE_HREF;
  _subsBars: Subscription;
  subscriptions = {};

  constructor(
    private _logSvc: LogService,
    private _webfeederHttpSvc: WebfeederHttpService,
    private _notificationSvc: NotificationAlertService,
    private _candleChartWebfeederSktSvc: CandleChartWebfeederSktService
  ) { }

  async onReady(callback: OnReadyCallback): Promise<void> {
    const configuration = await this.getConfiguration();
    this._setupWithConfiguration(configuration);
    callback(configuration);

  }

  private async getConfiguration(): Promise<DatafeedConfiguration & {
    supports_search: any;
    supports_group_request: any;
  }> {
    return of(defaultConfiguration()).toPromise();
  }

  // getServerTime?(callback: ServerTimeCallback): void {
  //   throw new Error('Method not implemented.');
  // }

  getMarks?(symbolInfo: LibrarySymbolInfo, from: number, to: number, onDataCallback: GetMarksCallback<Mark>, resolution: ResolutionString): void {
    this._logSvc.error(`Method getMarks not implemented`);
    throw new Error('Method not implemented.');
  }
  getTimescaleMarks?(symbolInfo: LibrarySymbolInfo, from: number, to: number, onDataCallback: GetMarksCallback<TimescaleMark>, resolution: ResolutionString): void {
    this._logSvc.error(`Method getTimescaleMarks not implemented`);
    throw new Error('Method not implemented.');
  }
  searchSymbols(userInput: string, exchange: string, symbolType: string, onResult: SearchSymbolsCallback): void {
    if (this._config.supports_search) {
      const params = {
        limit: 30,
        query: userInput.toUpperCase(),
        type: symbolType,
        exchange,
      };

      this._webfeederHttpSvc.symbolChartSearch(params).toPromise().then(
        response => {
          if (response.s !== undefined) {
            this._logSvc.error(`UdfCompatibleDatafeed: search symbols error=${response.errmsg}`);
            onResult([]);
            return;
          }
          if (response && response.length > 0) {
            response.forEach(element => {
              element.description = element.description ?? '';
            });
          }

          onResult(response);
          onResult([]);
        }).catch(error => {
          onResult([]);
        });





      // this._send<UdfSearchSymbolsResponse | UdfErrorResponse>('search', params)
      //   .then((response: UdfSearchSymbolsResponse | UdfErrorResponse) => {
      //     if (response.s !== undefined) {
      //       logMessage(`UdfCompatibleDatafeed: search symbols error=${response.errmsg}`);
      //       onResult([]);
      //       return;
      //     }
      //     if (response && response.length > 0) {
      //       response.forEach(element => {
      //         element.description = element.description == null ? '' : element.description;
      //       });
      //     }

      //     onResult(response);
      //   })
      //   .catch((reason?: string | Error) => {
      //     this._logSvc.error(`UdfCompatibleDatafeed: Search symbols for '${userInput}' failed. Error=${reason}`);
      //     onResult([]);
      //   });
    } else {
      // if (this._symbolsStorage === null) {
      //   throw new Error('UdfCompatibleDatafeed: inconsistent configuration (symbols storage)');
      // }

      // this._symbolsStorage.searchSymbols(userInput, exchange, symbolType, Constants.SearchItemsLimit)
      //   .then(onResult)
      //   .catch(onResult.bind(null, []));
    }
  }

  resolveSymbol(symbolName: string, onResolve: ResolveCallback, onError: DatafeedErrorCallback, extension?: SymbolResolveExtension): void {
    const resolveRequestStartTime = Date.now();
    this._webfeederHttpSvc.getSymbolInformation(symbolName).toPromise().then(
      response => {
        this._logSvc.debug(`Symbol resolved: ${Date.now() - resolveRequestStartTime}ms`);
        onResolve(response);
      });
  }


  convertTimestamptoString(unixtimestamp: number) {
    const date = new Date(unixtimestamp * 1000);
    const dateNow = new Date();
    // Year
    const year = date.getFullYear() === 0 ? dateNow.getFullYear() : date.getFullYear();
    // Month
    let month: any = date.getMonth() + 1 === 0 ? dateNow.getMonth() : date.getMonth() + 1;
    // Day
    let day: any = date.getDate() === 0 ? dateNow.getDate() : date.getDate();
    // Hours
    let hours: any = date.getHours();
    // Minutes
    let minutes: any = date.getMinutes();
    if (month < 10) {
      month = '0' + month;
    }
    if (day < 10) {
      day = '0' + day;
    }
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    // Display date time in YYYY/MM/DD hh:mm format
    return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes;
  }

  getBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: ResolutionString,
    periodParams: PeriodParams,
    onResult: HistoryCallback,
    onError: DatafeedErrorCallback): any {
    const resolveRequestStartTime = Date.now();
    let resolutionString: any = resolution;
    if (resolution === '1D') { resolutionString = 'D'; }

    const symbol = symbolInfo.ticker ? symbolInfo.ticker.toUpperCase() : symbolInfo.name.toUpperCase();
    const requestParams = {
      resolution: resolutionString,
      symbol,
      from: this.convertTimestamptoString(periodParams.to),
      to: this.convertTimestamptoString(periodParams.to),
    };

    if(periodParams.firstDataRequest){
      requestParams['countBack'] = periodParams.countBack;
    }

    this._webfeederHttpSvc.getBars(symbol, requestParams).toPromise().then(
      (response: any) => {
        this._logSvc.debug(`Symbol resolved: ${Date.now() - resolveRequestStartTime}ms`);
        if (!(['no_data', 'invalid_data', 'ok'].includes(response.s))) {
          onError(response.s);
          return;
        }
        const bars: Bar[] = [];
        const meta: HistoryMetadata = {
          noData: false,
        };
        if ((['no_data', 'invalid_data'].includes(response.s))) {
          meta.noData = true;
          meta.nextTime = response.nextTime;
          if (response.s == 'no_data') {
            this._notificationSvc.info('', `Sem dados hitórico[${requestParams.from}-${requestParams.to}] para o gráfico de ${symbol}!`)
          }
          if (response.s == 'invalid_data') {
            this._notificationSvc.error("", `Infelizmente não foi possível obter os dados do gráfico de ${symbol}!`)
          }
        } else {
          const volumePresent = response.v !== undefined;
          const ohlPresent = response.o !== undefined;

          for (let i = 0; i < response.t.length; ++i) {
            const barValue: Bar = {
              time: response.t[i] * 1000,
              close: Number(response.c[i]),
              open: Number(response.c[i]),
              high: Number(response.c[i]),
              low: Number(response.c[i]),
            };

            if (ohlPresent) {
              barValue.open = Number((response).o[i]);
              barValue.high = Number((response).h[i]);
              barValue.low = Number((response).l[i]);
            }

            if (volumePresent) {
              barValue.volume = Number((response).v[i]);
            }
            bars.push(barValue);
          }
        }

        if(response.c.length == 0){
          meta.noData = true;
        }

        onResult(bars, meta);
      })
  }

  async subscribeBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: ResolutionString,
    onTick: SubscribeBarsCallback,
    listenerGuid: string, onResetCacheNeededCallback: () => void): Promise<void> {
    const resolutionString = resolution === '1D' ? 'D' : resolution;
    const symbol = symbolInfo.ticker ? symbolInfo.ticker.toUpperCase() : symbolInfo.name.toUpperCase();
    const params = {
      quote: symbol,
      period: resolutionString,
      dispatch: true,
      // initDate: moment().subtract(1, 'minutes').format('YYYYMMDDHHmm'),
      quantity: 2,
      realTime: true
    };
    this.subscriptions[listenerGuid] = { params };
    const barsSubject = await this._candleChartWebfeederSktSvc.on({ ...params });
    this._logSvc.info(`Subscribe[${listenerGuid}] bars to symbol: ${params.quote} in ${params.period}`);

    this.subscriptions[listenerGuid].subscribe = barsSubject.subscribe(
      message => {
        if (message) {
          const messageObj = message;
          if (messageObj.error == '' &&
            messageObj.quote.toUpperCase() === symbol.toUpperCase() &&
            messageObj.candles && messageObj.candles.length > 0
          ) {
            if (message && message.candles && message.candles.length < 2) {
              return;
            }

            const lastCandle = Object.assign({}, message.candles[message.candles.length - 1]);
            const lastBar = {
              close: lastCandle.price,
              high: lastCandle.high,
              low: lastCandle.low,
              open: lastCandle.open,
              time: moment(lastCandle.date, 'YYYYMMDDHHmm').valueOf(),
              volume: parseInt(lastCandle.fVol)
            };
            onTick(lastBar);

          } else if (messageObj.error != '') {
            this._logSvc.error('Error updating chart data - ' + JSON.stringify(messageObj.error));
            // this._configService.writeLog('Error updating chart data - ' + JSON.stringify(messageObj.error))
          }
        }


      }
    );

  }


  unsubscribeBars(listenerGuid: string): void {
    this._logSvc.debug(`Call to unsubscribe[${listenerGuid}] bars to symbol`);
    if(this.subscriptions[listenerGuid]){
      const params = this.subscriptions[listenerGuid].params;
      // if(this.canUnsubscribeOnServer(listenerGuid)){
        if(this.subscriptions[listenerGuid].subscribe){
          this.subscriptions[listenerGuid].subscribe.unsubscribe();
        }
        this._candleChartWebfeederSktSvc.off({ ...params });
      // }

      this._logSvc.debug(`Unsubscribe[${listenerGuid}] bars to symbol: ${params.quote} in ${params.period}`);
      delete this.subscriptions[listenerGuid];
    }
  }

  canUnsubscribeOnServer(listenerGuid){
    const assetKey = this.getAssetKey(listenerGuid);

    // Check if there are other subscriptions for the same asset
    const hasOtherSubscriptions = Object.keys(this.subscriptions).some(subscriptionKey => {
      return subscriptionKey.startsWith(assetKey) && subscriptionKey !== listenerGuid;
    });

    if (!hasOtherSubscriptions) {
      return true;
    } else {
      return false;
    }
  }

   /**
   * Extracts the asset key (e.g., 'WINZ24') from a subscription key
   * @param key The subscription key
   * @returns string - The asset key
   */
   private getAssetKey(key: string): string {
    return key.split('_#_')[0];
  }

  subscribeDepth?(symbol: string, callback: any): string {
    this._logSvc.error(`Method subscribeDepth not implemented`);
    throw new Error('Method not implemented.');
  }
  unsubscribeDepth?(subscriberUID: string): void {
    this._logSvc.error(`Method unsubscribeDepth not implemented`);
    throw new Error('Method not implemented.');
  }
  getVolumeProfileResolutionForPeriod?(currentResolution: ResolutionString, from: number, to: number, symbolInfo: LibrarySymbolInfo): ResolutionString {
    this._logSvc.error(`Method getVolumeProfileResolutionForPeriod not implemented`);
    throw new Error('Method not implemented.');
  }

  getQuotes(symbols: string[], onDataCallback: QuotesCallback, onErrorCallback: (msg: string) => void): void {
    this._logSvc.error(`Method getQuotes not implemented`);
    throw new Error('Method not implemented.');
  }
  subscribeQuotes(symbols: string[], fastSymbols: string[], onRealtimeCallback: QuotesCallback, listenerGUID: string): void {
    this._logSvc.error(`Method subscribeQuotes not implemented`);
    throw new Error('Method not implemented.');
  }
  unsubscribeQuotes(listenerGUID: string): void {
    this._logSvc.error(`Method unsubscribeQuotes not implemented`);
    throw new Error('Method not implemented.');
  }

  public _setupWithConfiguration(configurationData: DatafeedConfiguration & { supports_search, supports_group_request }): void {
    this._config = configurationData;
    if (configurationData.exchanges === undefined) {
      configurationData.exchanges = [];
    }

    if (!configurationData.supports_search && !configurationData.supports_group_request) {
      throw new Error('Unsupported datafeed configuration. Must either support search, or support group request');
    }

    if (configurationData.supports_group_request || !configurationData.supports_search) {
      // this._symbolsStorage = new SymbolsStorage(this._datafeedURL, configurationData.supported_resolutions || [], this._requester);
      this._logSvc.info(`_setupWithConfiguration supports_group_request: ${configurationData.supports_group_request}`);
      this._logSvc.info(`_setupWithConfiguration !configurationData.supports_search: ${!configurationData.supports_search}`);
    }

    this._logSvc.info(`UdfCompatibleDatafeed: Initialized with ${JSON.stringify(configurationData)}`);
  }


}
